import { useMemo } from "react";
import { generateColumnsDefaultConfiguration } from "../../../../components/dataGrid/columnHelpers";
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from "react-router-dom";
import { CustomChip } from '../../../../components/chip/Chip';

export const useGetColumns = (idEstado) => {
    const navigate = useNavigate();
    const PrecioControlDetallePath = "/autorizacionPrecioControl/detalle";

    const handleClickView = (row) => {
        navigate(`${PrecioControlDetallePath}/${row.idAutorizacionControl}`, {
            state: {
                idEstado
            },
        });
    };

    const initialColumns = [
        {
            headerName: "",
            field: "action",
            flex: 45,
            sortable: false,
            align: "center",
            renderCell: (cellProps) => {
                const { row } = cellProps;
                return (
                    <div onClick={() => handleClickView(row)} aria-hidden='true' className="item-option clickable-option"
                        style={{ marginTop: '5px' }}>
                        <EditIcon className="edit-icon" />
                        <span className='toggle-action'>Editar</span>
                    </div>
                );
            },
        },
        {
            flex: 80,
            field: 'idAutorizacionControl',
            headerName: '#'
        },
        {
            flex: 100,
            field: 'region',
            headerName: 'Region'
        },
        {
            flex: 100,
            field: 'delegacion',
            headerName: 'Delegacion'
        },
        {
            flex: 100,
            field: 'evento',
            headerName: 'Evento'
        },
        {
            flex: 120,
            field: 'fecha',
            headerName: 'Fecha',
        },
        {
            flex: 200,
            field: 'solicitante',
            headerName: 'Solicitante'
        },
        {
            flex: 80,
            field: 'contrato',
            headerName: 'Contrato'
        },
        {
            flex: 200,
            field: 'modulo',
            headerName: 'Plan'
        },
        {
            flex: 100,
            field: 'codigo',
            headerName: 'Codigo'
        },
        {
            flex: 80,
            field: 'idMinuta',
            headerName: 'Minuta'
        },
        {
            flex: 200,
            field: 'financiador',
            headerName: 'Financiador'
        },
        {
            flex: 200,
            field: 'periodo',
            headerName: 'Periodo'
        },
        {
            flex: 120,
            field: 'precioControl',
            headerName: 'PN2',
            valueGetter: (precioControl) => {
                return '$' + precioControl?.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }
        },
        {
            flex: 120,
            field: 'precioACambiar',
            headerName: 'Precio A Cambiar',
            valueGetter: (precioACambiar) => {
                return '$' + precioACambiar?.toLocaleString('es-AR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            }
        }
    ];


    const columns = useMemo(() => generateColumnsDefaultConfiguration(initialColumns, true), [idEstado]);

    return columns;
}


